/*
 * Shopify-only fundraising bridge.
 *
 * Include this asset in the Shopify theme after the school selector. It records the
 * selected participating school as private cart attributes so the identifiers follow
 * the native cart into the Shopify order. A public school-name attribute is included
 * only so the cart can confirm the supported school to the customer. Contribution
 * values are deliberately not accepted from the browser; the server derives them from
 * trusted SKUs.
 */
(function () {
  'use strict';

  var ATTRIBUTE_NAMES = Object.freeze({
    id: '__fundraising_school_id',
    name: '__fundraising_school_name',
    code: '__fundraising_code',
    displayName: 'fundraising_school_name'
  });
  var updateQueue = Promise.resolve();

  function clean(value, limit) {
    return String(value || '').trim().slice(0, limit);
  }

  function cartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return String(root).replace(/\/?$/, '/') + 'cart/update.js';
  }

  function attributesFor(school) {
    var validSchool = school
      && clean(school.id, 100)
      && clean(school.name, 160)
      && clean(school.fundraising_code, 100);

    return {
      __fundraising_school_id: validSchool ? clean(school.id, 100) : '',
      __fundraising_school_name: validSchool ? clean(school.name, 160) : '',
      __fundraising_code: validSchool ? clean(school.fundraising_code, 100) : '',
      fundraising_school_name: validSchool ? clean(school.name, 160) : ''
    };
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function syncSchool(school) {
    var attributes = attributesFor(school);

    updateQueue = updateQueue.catch(function () {
      // A failed request must not prevent a later selection from being saved.
    }).then(function () {
      return window.fetch(cartUpdateUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (response) {
        if (!response.ok) throw new Error('Shopify cart attributes could not be updated.');
        return response.json();
      }).then(function (cart) {
        var received = cart && cart.attributes || {};
        if (attributes[ATTRIBUTE_NAMES.code]
          && (received[ATTRIBUTE_NAMES.id] !== attributes[ATTRIBUTE_NAMES.id]
            || received[ATTRIBUTE_NAMES.name] !== attributes[ATTRIBUTE_NAMES.name]
            || received[ATTRIBUTE_NAMES.code] !== attributes[ATTRIBUTE_NAMES.code])) {
          throw new Error('Shopify did not retain the selected school. Please choose it again.');
        }
        emit('crown:shopify-fundraising-synced', {
          cart: cart,
          schoolCode: attributes[ATTRIBUTE_NAMES.code] || null
        });
        return cart;
      }).catch(function (error) {
        emit('crown:shopify-fundraising-error', { message: error.message });
        throw error;
      });
    });

    return updateQueue;
  }

  document.addEventListener('crown:fundraising-school', function (event) {
    syncSchool(event.detail && event.detail.school).catch(function () {
      // The error event above lets the theme show a recoverable message if desired.
    });
  });

  window.CrownStandardShopifyFundraising = Object.freeze({
    attributeNames: ATTRIBUTE_NAMES,
    syncSchool: syncSchool
  });
})();
